module.exports = __webpack_public_path__ + "img/code.dcdfd3ab.png";